<template>
  <div class="box">
    <!-- 我的成就 -->
    <div class="t1">{{ $t('我的成就') }}</div>
    <div class="tab">
      <span :class="{ 'active': flog == 1 }" @click="flog = 1">{{ $t('证书') }}</span>
      <span :class="{ 'active': flog == 2 }" @click="flog = 2">{{ $t('贡献') }}</span>
    </div>

    <div>
      <!-- 证书 -->
      <div v-if="flog == 1">
        <div class="list df aife">
          <template v-if="userData.tesa_status == 20">
            <img :src="userData.contract_arr" style="width: 60%;" alt="">
            <el-button class="btn fn"  @click="downloadCertificate">{{ $t('下载证书') }}</el-button>
          </template>
          <template v-else>
            <div class="no-data">
              <img src="@/assets/images/empty_data.png" alt="">
              <p>{{ $t('暂无数据') }}</p>
            </div>
          </template>
        </div>
      </div>
      <!-- 贡献 -->
      <div v-if="flog == 2">
        <div class="list df aife">
          <div class="no-data">
            <img src="@/assets/images/empty_data.png" alt="">
            <p>{{ $t('暂无数据') }}</p>
          </div>
          <!--          <img src="@/assets/images/img/zs.png" alt="">-->
          <!--          <el-button class="btn fn">{{$t('下载证书')}}</el-button>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getExpertInfo } from "@api/expert";

export default {

  data() {
    return {
      flog: 1,
      userData: [],
    }
  },
  mounted() {
    // 设置默认的顶部菜单背景色
    this.$bus.$emit('changeNavbg', 'rgba(255, 255, 255, 1);');
    this.getData();
  },
  methods: {
    // 获取用户信息
    async getData() {
      this.userinfo = JSON.parse(localStorage.getItem('userinfo'));
      let Language = localStorage.getItem('currentLanguage');  //获取本地语言
      const res = await getExpertInfo({ user_id: this.userinfo.user_id });
      if (res.status == 200) {
        this.userData = res.data;
      }
    },
    downloadCertificate() {
      let contract = JSON.parse(this.userData.contract);
      window.location.href = `/protal/download/downAnnex?content_id=999999&att_id=${contract[0].att_id}&type=10`; // 触发下载
    }
  }


}
</script>

<style lang="scss" scoped>
.box {
  border: 1px solid rgb(243, 243, 243);
  border-radius: 8px;
  /* shadow-l */
  box-shadow: -2px 0px 12px 0px rgba(0, 0, 0, 0.08);
  background: rgb(255, 255, 255);
  padding: 24px 40px 56px;
  margin-top: 16px;

  .list {
    margin-top: 20px;


    .btn {
      min-width: 98px;
      height: 36px;
      border: 1px solid rgb(0, 0, 0);
      border-radius: 23px;
      padding: 0 16px;
      font-size: 14px;
      color: #000000;
      background: #ffffff;
      background-color: #ffffff;
      margin-left: 20px;

      &:hover {
        color: #D80F05;
        border: 1px solid #D80F05;
      }


    }
  }

  .tab {
    margin-top: 20px;

    .active {
      font-size: 17px;
      font-family: "MicrosoftYaHeiSemibold";

      border-bottom: 1px solid rgb(183, 37, 30);
    }

    span:hover {
      font-size: 17px;
      font-family: "MicrosoftYaHeiSemibold";
    }

    span {
      color: rgb(25, 25, 25);
      font-size: 15px;
      font-weight: 400;
      line-height: 24px;
      margin-right: 19px;
      padding-bottom: 2px;
      cursor: pointer;
      transition: all .36s;
    }
  }

  .t1 {
    color: rgb(25, 25, 25);
    font-family: "MicrosoftYaHeiSemibold";
    font-size: 20px;
    font-weight: 400;
    line-height: 24px;
  }
}
</style>